/* ============================================================
   Product block: Countdown (standalone)
   Self-contained timer for the product / featured product
   countdown block. Independent of theme.Countdown and the
   Countdown section.
   ============================================================ */
(function () {
  function parseOffset(str) {
    // Shop's UTC offset in minutes, from a "+0100" / "-0500" style string
    if (!str) return 0;
    var sign = str.charAt(0) === '-' ? -1 : 1;
    var h = parseInt(str.substr(1, 2), 10) || 0;
    var m = parseInt(str.substr(3, 2), 10) || 0;
    return sign * (h * 60 + m);
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function initTimer(el) {
    // Guard against binding more than one interval to the same timer
    if (el.dataset.productCountdownActive === 'true') return;
    el.dataset.productCountdownActive = 'true';

    var timestamp = parseInt(el.getAttribute('data-launch-date'), 10);
    var dailyReset = el.getAttribute('data-daily-reset') === 'true';
    if (!dailyReset && !timestamp) return;

    var offsetMins = parseOffset(el.getAttribute('data-shop-offset'));
    var timer = el.querySelector('[data-countdown-timer]');
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minsEl = el.querySelector('[data-mins]');
    var secsEl = el.querySelector('[data-secs]');

    // Next midnight in the shop's local timezone, as a real UTC timestamp in ms
    // (recomputed each tick so it rolls over automatically at store-local midnight)
    function nextShopMidnight() {
      var offsetMs = offsetMins * 60000;
      var shopNow = new Date(Date.now() + offsetMs);
      var shopMidnight = Date.UTC(
        shopNow.getUTCFullYear(),
        shopNow.getUTCMonth(),
        shopNow.getUTCDate() + 1,
        0, 0, 0, 0
      );
      return shopMidnight - offsetMs;
    }

    var interval = setInterval(function () {
      var end = dailyReset ? nextShopMidnight() : timestamp * 1000;
      var t = end - Date.now();

      if (!dailyReset && t < 0) {
        clearInterval(interval);
        var msg = el.getAttribute('data-ended-message') || '';
        if (timer) {
          timer.innerHTML = '<span class="product-countdown__ended"></span>';
          timer.firstChild.textContent = msg;
        }
        return;
      }

      var days = Math.floor(t / 86400000);
      var hours = Math.floor((t / 3600000) % 24);
      var mins = Math.floor((t / 60000) % 60);
      var secs = Math.floor((t / 1000) % 60);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }, 1000);
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-product-countdown]')
      .forEach(initTimer);
  }

  if (document.readyState !== 'loading') {
    initAll(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  }

  // Theme editor: re-init when a section is re-rendered or selected
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    initAll(e.target);
  });
})();
